import { dangerColor, labelColor, newsecondaryColor, regularFont, whiteColor } from "@app/styles"
import styled from "styled-components"

export const PopUpWrapper = styled.div`
position: fixed;
top: 0;
left: 0;
width: 100vw;
height: 100vh;
background-color: rgba(0,0,0,0.5);
display: flex;
align-items: center;
justify-content: center;
z-index: 20;
`

export const PopUpContainer = styled.div`
height: 500px;
min-width: 700px;
max-width: 700px;
min-height: 200px;
background-color: ${whiteColor};
box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.25);
border-radius: 8px;
padding: 48px 36px;
display: flex;
flex-direction: column;
align-items: center;
font-family: "Poppins", sans-serif;
position: relative;
svg{
  margin-bottom: 16px;
}
@media (max-width: 575px) {
  min-width: calc(100vw - 16px);
  max-width: calc(100vw - 16px);
}
.close-icon{
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
  opacity: 0.75;
  transition: all 0.3s ease;
  &:hover{
    opacity: 1;
  }
}
&.alt-padding{
  padding: 32px 48px;
}
`

export const PopUpTitle = styled.h3`
font-size: 30px;
${regularFont};
line-height: 1;
color: ${newsecondaryColor};
text-align: center;
line-height: 1.35;
&.red{
  color: ${dangerColor};
}
`

export const PopUpSubTitle = styled.h4`
font-size: 22px;
${regularFont};
line-height: 1;
color: ${labelColor};
text-align: center;
line-height: 1.5;
margin: 16px 0 0;
.phone{
  color: ${newsecondaryColor}
}
`

export const PopUpText = styled.p`
font-size: 16px;
${regularFont};
line-height: 1.35;
color: ${labelColor};
margin: 32px 0 0;
@media (max-width: 575px){
  text-align: center;
}
`